export default function ButtonBlock({ settings }) {
  const { padding, margin, borderWidth, borderColor, borderRadius } = settings

  const containerStyle = {
    margin: `${margin.top} ${margin.right} ${margin.bottom} ${margin.left}`,
    textAlign: settings.textAlign
  }

  const buttonStyle = {
    display: 'inline-block',
    padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`,
    fontSize: settings.fontSize,
    fontFamily: settings.fontFamily,
    fontWeight: settings.fontWeight,
    color: settings.color,
    backgroundColor: settings.backgroundColor,
    border: (borderWidth && borderWidth !== '0px') ? `${borderWidth} solid ${borderColor || '#0056b3'}` : 'none',
    borderRadius: borderRadius || '0px',
    textDecoration: 'none',
    cursor: 'pointer',
    width: settings.width === 'auto' ? 'auto' : settings.width
  }

  return (
    <div style={containerStyle}>
      <a href={settings.link} style={buttonStyle}>
        {settings.text}
      </a>
    </div>
  )
}
